/**
 * Function that builds the last part of a path based on an object
 * with the parameters, creating a string that starts with the
 * question mark (?) and the ampersand (&) respectively.
 */
export const makeUrlWithParams = paramsObject => {
  let restUrl = ''
  Object.keys(paramsObject).forEach((key, index) => {
    const value = paramsObject[key]
    if (value) {
      if (index !== 0 && restUrl[restUrl.length - 1] !== '&') restUrl = `${restUrl}&`
      restUrl = `${restUrl}${key}=${value}`
    }
  })
  return restUrl === '?' ? '' : restUrl
}
